(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4350],{

/***/ 34481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ HTMLParser; }
/* harmony export */ });
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25935);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_elements_Icon_ExternalLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var isExternalLink = function isExternalLink(domNode) {
  if (domNode.name !== 'a') {
    return false;
  }

  if (domNode.attribs.href.startsWith('https://trial-holdings.inc')) {
    return false;
  }

  return true;
};

var HTMLParser = function HTMLParser(_ref) {
  var text = _ref.text;

  var parser = function parser(input) {
    return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(input, {
      replace: function replace(domNode) {
        if (domNode instanceof html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* .Element */ .W_) {
          var _domNode$firstChild;

          if (domNode.attribs["class"] === 'remove') {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
          }

          if (isExternalLink(domNode) && ((_domNode$firstChild = domNode.firstChild) === null || _domNode$firstChild === void 0 ? void 0 : _domNode$firstChild.type) === 'text') {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
              href: domNode.attribs.href,
              rel: "noopener noreferrer",
              target: "_blank",
              children: [domNode.firstChild.data, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Icon_ExternalLink__WEBPACK_IMPORTED_MODULE_2__/* .ExternalLinkIcon */ .h, {
                size: "small"
              })]
            });
          }
        }
      }
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: parser((0,isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__.sanitize)(text))
  });
};

/***/ }),

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 99903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ NewsTagButton; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["tag", "isActive", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NewsTagButton = function NewsTagButton(_ref) {
  var tag = _ref.tag,
      isActive = _ref.isActive,
      size = _ref.size,
      props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var tagColor = tag.code === 'importantNotices' ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.red */ .r.colors.red : _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(TagButton, _objectSpread(_objectSpread({
    type: "button",
    "aria-pressed": isActive,
    color: tagColor,
    size: size
  }, props), {}, {
    children: tag.name
  }));
};
var SmallButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["font-size:13px;letter-spacing:0;line-height:23px;padding:0 28px;height:25px;"]);
var RegularButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["font-size:16px;line-height:27px;padding:0 18px;height:36px;@media screen and (max-width:1047px){height:34px;font-size:14px;line-height:24px;}"]);
var TagButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "NewsTagButton__TagButton",
  componentId: "sc-rtr6u2-0"
})(["", ";border:", ";border-radius:2px;cursor:pointer;transition:0.3s;color:", ";background-color:#ffffff;&[disabled]{cursor:default;}@media (hover:hover){&:hover{opacity:0.6;}}&[aria-pressed='true']{color:#ffffff;background-color:", ";}"], function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? SmallButton : RegularButton;
}, function (_ref3) {
  var color = _ref3.color;
  return "1px solid ".concat(color);
}, function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var color = _ref5.color;
  return color;
});

/***/ }),

/***/ 64948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PDFLink; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var PDFLink = function PDFLink(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Anchor, {
    href: url,
    target: "_blank",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H, {}), "PDF"]
  });
};
var Anchor = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFLink__Anchor",
  componentId: "sc-1q77mcf-0"
})(["display:flex;align-items:center;justify-content:center;gap:10px;width:198px;height:50px;font-size:18px;line-height:26px;letter-spacing:0;color:", ";border:1px solid ", ";border-radius:29px;transition:0.3s;&:hover{background:", ";border-color:", ";color:#ffffff;> svg{fill:#ffffff;}}@media screen and (max-width:1047px){position:relative;> svg{position:absolute;left:21px;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 85801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ NewsArticlePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/components/elements/HTMLParser/index.tsx
var HTMLParser = __webpack_require__(34481);
// EXTERNAL MODULE: ./src/components/elements/News/NewsTagButton/index.tsx
var NewsTagButton = __webpack_require__(99903);
// EXTERNAL MODULE: ./src/components/elements/PDFLink/index.tsx
var PDFLink = __webpack_require__(64948);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/News/Release/NewsId/NewsArticle.tsx










var NewsArticle = function NewsArticle(_ref) {
  var tag = _ref.tag,
      title = _ref.title,
      body = _ref.body,
      pdf = _ref.pdf,
      publishDate = _ref.publishDate;
  var router = (0,next_router.useRouter)();

  var handleSearchTag = function handleSearchTag(tag) {
    router.push({
      pathname: '/news/release',
      query: {
        tag: tag
      }
    }, '/news/release');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Article, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderMeta, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TagList, {
            children: tag.map(function (tag) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsTagButton/* NewsTagButton */.j, {
                tag: tag,
                size: "small",
                isActive: false,
                onClick: function onClick() {
                  return handleSearchTag(tag.name);
                }
              }, tag.name);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NewsArticle_Date, {
            dateTime: publishDate,
            children: (0,date/* formatDate */.p6)(publishDate, 'yyyy年MM月dd日')
          })]
        }), pdf && /*#__PURE__*/(0,jsx_runtime.jsx)(PDFLink/* PDFLink */.Q, {
          url: pdf.src
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 70
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HTMLParser/* HTMLParser */.J, {
        text: body
      })
    })]
  });
};
var HeaderMeta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NewsArticle__HeaderMeta",
  componentId: "sc-c1rx7q-0"
})(["display:flex;justify-content:space-between;align-items:center;@media screen and (max-width:1047px){flex-direction:column;justify-content:initial;align-items:flex-start;gap:26px;}"]);
var Article = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "NewsArticle__Article",
  componentId: "sc-c1rx7q-1"
})(["width:1040px;margin:74px auto 130px;@media screen and (max-width:1047px){width:100%;margin:40px auto 80px;padding:0 20px;}"]);
var TagList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NewsArticle__TagList",
  componentId: "sc-c1rx7q-2"
})(["display:flex;align-items:center;gap:12px;margin-bottom:10px;@media screen and (max-width:1047px){gap:11px;}"]);
var NewsArticle_Date = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "NewsArticle__Date",
  componentId: "sc-c1rx7q-3"
})(["font-size:18px;line-height:26px;letter-spacing:0;color:", ";@media screen and (max-width:1047px){font-size:14px;line-height:24px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "NewsArticle__Title",
  componentId: "sc-c1rx7q-4"
})(["font-size:28px;font-weight:bold;letter-spacing:1.68px;line-height:42px;color:", ";@media screen and (max-width:1047px){font-size:24px;letter-spacing:0.96px;line-height:36px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "NewsArticle__Section",
  componentId: "sc-c1rx7q-5"
})(["p{font-size:18px;letter-spacing:0.36px;line-height:34px;color:", ";margin-bottom:20px;}a{color:", ";&:hover{text-decoration:underline;}> svg{margin-left:8px;}}strong{font-weight:bold;}em{font-style:italic;}img{max-width:100%;}h2{font-size:24px;font-weight:bold;letter-spacing:1.44px;line-height:42px;color:", ";margin-top:40px;margin-bottom:20px;}h3{font-size:22px;font-weight:bold;letter-spacing:1.32px;line-height:42px;color:", ";margin-top:40px;margin-bottom:20px;}@media screen and (max-width:1047px){p{font-size:15px;letter-spacing:0.3px;line-height:25px;}a{text-decoration:underline;word-break:break-all;}h2{font-size:22px;letter-spacing:0.44px;line-height:33px;margin-top:29px;margin-bottom:18px;}h3{font-size:20px;letter-spacing:0.4px;line-height:42px;margin-top:29px;margin-bottom:18px;}}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.textTitle */.r.colors.textTitle);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/News/Release/NewsId/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var NewsArticlePage = function NewsArticlePage(_ref) {
  var news = _ref.news;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsArticle, _objectSpread({}, news));
};

NewsArticlePage.getLayout = function getLayout(page) {
  var _utilMeta$blogUtilMet;

  var pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム'
  };
  var _page$props$news = page.props.news,
      _id = _page$props$news._id,
      title = _page$props$news.title,
      utilMeta = _page$props$news.utilMeta;
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news/'
  }, {
    name: 'ニュースリリース',
    path: '/news/release'
  }, {
    name: title,
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: title,
      description: (utilMeta === null || utilMeta === void 0 ? void 0 : utilMeta.blogUtilMeta.description) || '',
      ogp: {
        type: 'article',
        url: "news/release/".concat(_id),
        image: utilMeta === null || utilMeta === void 0 ? void 0 : (_utilMeta$blogUtilMet = utilMeta.blogUtilMeta) === null || _utilMeta$blogUtilMet === void 0 ? void 0 : _utilMeta$blogUtilMet.ogImage
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      children: page
    }))]
  });
};
;// CONCATENATED MODULE: ./src/pages/news/release/[newsId].tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 24560:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/release/[newsId]",
      function () {
        return __webpack_require__(85801);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(61587)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,2167,342,5548,9774,2888,179], function() { return __webpack_exec__(24560); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);